const LiveCalendar = {
  async fetch({ params, timeSpan = 'month', dated, locationId = null }) {
    const locationParam = locationId ? `/location/${locationId}` : '';
    const url = `${params.getApiUrl()}/sxcl/v1/availability/service-providers/${params.pageId}${locationParam}/schedule-calendar/${timeSpan}`;
    const response = await params?.get(url, { date: dated });
    return response;
  },
};

export default LiveCalendar;
